import React from 'react';
import clsx from 'clsx';
import {
  AspectRatio,
  MediaQuery,
  MediaQueryPictureOrder,
  MediaQueryStyleOrder,
  generateImageRenditions,
  sortRenditions,
} from '../../utils/ImageUtils';
import * as Styled from './AImage.styles';
import { type AImageProps } from './AImage.types';

const COMPONENT_NAME = 'a-web-ui-kit-AImage';
const TEST_ID = 'web-ui-kit-AImage';

export function AImage(props: AImageProps): JSX.Element {
  const { imgClass, title, src, alt = '', loading = 'lazy', renditions = [], ...restProps } = props;

  // ensure renditions are sorted in correct order for picture source elements
  // and style definitions, respectively -- the order is very significant
  const pictureRenditions = sortRenditions(renditions, MediaQueryPictureOrder);
  const styleRenditions = sortRenditions(renditions, MediaQueryStyleOrder);

  return (
    <Styled.AImagePicture
      renditions={styleRenditions}
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      {...restProps}
    >
      {pictureRenditions.map((rendition, index: number) => {
        const { renditionPath, media } = rendition;
        return (
          <source
            key={index}
            media={media}
            srcSet={renditionPath}
            data-srcset={renditionPath}
            data-testid={`${TEST_ID}-source-img-${index}`}
          />
        );
      })}

      <img
        src={src}
        className={clsx('image', loading, imgClass)}
        alt={alt}
        data-src={src}
        loading={loading}
        title={title}
      />
    </Styled.AImagePicture>
  );
}

export {
  AspectRatio as AImageAspectRatio,
  MediaQuery as AImageMediaQuery,
  generateImageRenditions,
  TEST_ID as A_IMAGE_TEST_ID,
};
